import { Customer, ThemeDoc } from '@livekatsomo/models';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import List from '@mui/material/List';

import { useListMenu } from '@livekatsomo/web/hooks';
import {
  ListItemMenu,
  ListItemMenuProps,
} from '@livekatsomo/web/ui-components/layout';
import { ThemeListItem } from './ThemeListItem';
import { useTranslation } from 'next-i18next';

export interface CustomerThemesCardProps
  extends Omit<ListItemMenuProps<ThemeDoc>, 'selectedItem' | 'onClose'> {
  themes?: ThemeDoc[];
  customer: Customer;
  onAddTheme: () => void;
  onEditTheme: (themeId: string) => void;
}

export function CustomerThemesCard({
  themes,
  customer,
  onAddTheme,
  onCopy,
  onSetAsCurrent,
  onDelete,
  onEditTheme,
}: CustomerThemesCardProps) {
  const { selectedItem, closeMenu, openMenu } = useListMenu<ThemeDoc>();
  const { t } = useTranslation();
  return (
    <Card aria-labelledby="themes-card-header">
      <CardHeader title={t('Themes')} id="themes-card-header" />
      <CardContent sx={{ maxHeight: '70vh', overflowY: 'auto' }}>
        <List>
          {themes?.map((theme) => (
            <ThemeListItem
              key={theme.id}
              onClick={() => onEditTheme(theme.id)}
              currentThemeId={customer.theme?.id}
              theme={theme}
              showMenu={Boolean(onCopy || onSetAsCurrent)}
              onMenuClick={openMenu}
            />
          ))}
        </List>

        <ListItemMenu
          selectedItem={selectedItem}
          onClose={closeMenu}
          onCopy={onCopy}
          onSetAsCurrent={onSetAsCurrent}
          onDelete={onDelete}
        />
      </CardContent>
      <CardActions>
        <Button size="small" onClick={onAddTheme}>
          {t('Add theme')}
        </Button>
      </CardActions>
    </Card>
  );
}

export default CustomerThemesCard;
